import React, { FC } from "react";
import Styles from "./index.scss";

export interface Crumb {
    title: string;

    active?: boolean;
    external?: boolean;
    mask?: string;
    url?: string;
}

function getLiContent(t: Crumb) {
    if (!t.active) {
        if (t.external) {
            return <a href={t.url}>{t.title}</a>;
        }

        return <a href={t.url || ""}>{t.title}</a>;
    }

    return t.title;
}

interface BreadcrumbProps {
    trail: Crumb[];
}

const Breadcrumb: FC<BreadcrumbProps> = ({ trail }) => (
    <>
        <style jsx>{Styles}</style>
        <ul className="breadcrumbs">
            {trail && trail.map((t) => <li key={t.title}>{getLiContent(t)}</li>)}
        </ul>
    </>
);

export default Breadcrumb;
